import style_inject_es_default from "../../../../../../node_modules/.pnpm/style-inject@0.3.0/node_modules/style-inject/dist/style-inject.es.js";

//#region src/components/overlay/overlay.module.css
var css_248z = ".overlay-module_root__Gcj1J {\n    background: var(--mantine-color-gray-7);\n    opacity: 50%;\n}\n";
var overlay_module_default = { "root": "overlay-module_root__Gcj1J" };
style_inject_es_default(css_248z);

//#endregion
export { overlay_module_default as default };